import React from 'react';

import styles from './activity-id-viewer.style';
import { ThemedText } from '../themed-text';
import { ThemedView } from '../themed-view';

export function ActivityIdViewer({ id }) {
  return (
    <ThemedView type="primary" style={styles.container}>
      <ThemedText type="onPrimary">{id}</ThemedText>
    </ThemedView>
  );
}
